<app-header bgColor="rgb(90 99 255 / 59%)" [isHide]="true"></app-header>
<div class="contentWrapper">
    <div class="body-contained">
        <div class="body-center">
            <div class="d-flex justify-content-center">
                <img src="/assets/images/connect404.svg" class="connect-img" alt="connect logo" />
            </div>
            <h1 class="main-text">404</h1>
            <p class="page-not-found">page not found</p>
            <div class="d-flex justify-content-center">
                <a href="">
                    <button>BACK HOME</button>
                </a>
            </div>
        </div>
    </div>
</div>